// Get Creator Monthly Sales
export const GET_CREATOR_MONTHLY_SALES_REQUEST = 'GET_CREATOR_MONTHLY_SALES_REQUEST';
export const GET_CREATOR_MONTHLY_SALES_DONE = 'GET_CREATOR_MONTHLY_SALES_DONE';
export const GET_CREATOR_MONTHLY_SALES_FAILED = 'GET_CREATOR_MONTHLY_SALES_FAILED';

export const GET_CREATOR_MONTHLY_SALES_RESET = 'GET_CREATOR_MONTHLY_SALES_RESET';
